import React from 'react'
import Home from './Components/Home';
import { Route, Switch} from "react-router";
import Contact from './Components/Contactme/Contact';
import Error from './Components/Error/Error';
import Project from './Pages/Project';
import Works from './Pages/Itworks';
import About from './Pages/About';


const App = () => {
  return (
    <>
      <Switch>
        <Route exact path="/" component={Home}></Route>
        <Route path="/about" component={About}></Route>
        <Route path="/contact" component={Contact}></Route>
        <Route path="/project" component={Project}></Route>
        <Route path="/itworks" component={Works}></Route>
        <Route component={Error}></Route>
      </Switch>
    </>
  )
}

export default App
